type FacilityType = {
  uuid: string;
  name: string;
};

export const getSelectedFacilityName = (facilities: Array<FacilityType>) => {
  const facilityId = localStorage.getItem('facilityId') || '';
  const pullfacility = facilities.find((item: FacilityType) => item.uuid === facilityId);
  if (pullfacility) {
    return pullfacility.name;
  } else {
    return '';
  }
};
